import React, {useEffect, useState} from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useRouter from 'hooks/useRouter';
import {useDispatch, useSelector} from 'react-redux';
import * as actions from 'store/actions';

import useStyles from './styles';
import {toast} from "react-toastify";
import AGGridTable from "../../../AGGrid/AGGrid";
import Spinner from '../../../../components/Spinner/Spinner';

const GCPI = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {data, error, loaded} = useSelector((state) => state.turnover.gcpi);

    useEffect(() => {
        dispatch(actions.getGCPIData());
    }, []);

    const [colDefs, setColDefs] = useState([
        {
            field: 'year', headerName: 'Year', filter: 'agSetColumnFilter', cellStyle: {backgroundColor: 'lightgrey'}, cellRenderer: (params) => {
                return params.node.id === "5" ? params.value + "+" : params.value;
            },
        },
        {
            field: 'yearValue',
            headerName: 'GCPI Y/E %',
            cellDataType: 'number',
            valueFormatter: (params) => {
                return params.value ? params.value.toFixed(2) : '';
            }, editable: true
        },
        {
            field: 'averageValue',
            headerName: 'GCPI Average %',
            cellDataType: 'number',
            valueFormatter: (params) => {
                return params.value ? params.value.toFixed(2) : '';
            }, editable: true
        },
    ]);

    if (!loaded) {
      return <Spinner />;
    }

    if (error && loaded) {
      return (
        <Box className={classes.root}>
          <Typography color="error" variant="h5">
            {error}
          </Typography>
        </Box>
      );
    }

    return (
      <Box>
          <Box>
          <Typography variant="h5" className={classes.headerText}
                      style={{marginLeft: "25px"}}
                      sx={{
                          fontWeight: 400
                        }}
          >
              GCPI Figures
          </Typography>
          </Box>
        <AGGridTable
            data={data.gcpiList ? data.gcpiList.map((item) => {
                return {
                    id: item.id,
                    year: item.year,
                    yearValue: item.yearValue ? item.yearValue.value : null,
                    averageValue: item.averageValue ? item.averageValue.value : null
                }
            }) : []}
            colDefs={colDefs}
            classes={classes}
            updateHandler={(value, api) => {
                dispatch(actions.updateGCPIData(value.data.yearValue ? value.data.yearValue : null, value.data.averageValue ? value.data.averageValue : null, value.data.year))
                    .catch((err) => {
                        toast.error(err);
                    });
            }}
        />
      </Box>
    );
};

export default GCPI;
